import React from 'react'
import { connect } from 'react-redux'
import { Page } from '../../../../components/page/Page'
import { routes } from '../../../../constants'
import { actions } from '../pbatendimento.actions'
import { PbAtendimentoForm } from './PbAtendimentoForm'
import { DefaultToolBar } from '../../../../components/toolbar/DefaultToolBar'
import _ from 'lodash'

const mapStateToProps = (state) => {
  const record = state.crudPbAtendimentoState.currentRecord

  return {
    record,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setField: (field, value) => dispatch(actions.setField(field, value)),
    changeHandler: (event) => {
      const target = event.target
      const field = target.name
      let valor = target.value
      dispatch(actions.setField(field, valor))
    },
    executeCommand: (params) => dispatch(actions.executeCommand(params)),
  }
}

class PbAtendimentoFormPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.showPesquisarButton = false
    this.showCSVButton = false
    this.showColumnButton = false
    this.state = {
      dadosFavorito: null,
      favorito: 0,
      oidUnidade: null,
      oidAuxiliar: null,
      oidEmpresa: null,
    }
    actions.afterNew = () => {
      this.props.history.push(`${routes.PATH_PUBLIC_ATENDIMENTO}`)
    }
  }

  componentDidMount() {
    const split = this.props.location.pathname.split('/')
    const oidEmpresa = split[split.length - 3]
    const oidUnidade = split[split.length - 2]
    const oidAuxiliar = split[split.length - 1]
    this.setState({ oidEmpresa: oidEmpresa })
    this.setState({ oidUnidade: oidUnidade })
    this.setState({ oidAuxiliar: oidAuxiliar })
  }

  componentWillUnmount() {}

  loadFavorito() {}

  changeFavorito() {}

  buildHeader = () => {
    return (
      <div>
        <DefaultToolBar listPageContainer={this} title={'Atendimento'} hideFavorito={true} />
      </div>
    )
  }

  onClickSolicitarAtendimento = () => {
    const record = this.props.record
    const params = {
      oidEmpresa: this.state.oidEmpresa,
      oidUnidade: this.state.oidUnidade,
      oidAuxiliar: this.state.oidAuxiliar,
      nomeResponsavel: _.get(record, 'nomeResponsavel', ''),
      nomeFalecido: _.get(record, 'nomeFalecido', ''),
      foneResponsavel: _.get(record, 'foneResponsavel', ''),
    }
    this.props.executeCommand(params)
  }

  canSolicitarAtendimento = () => {
    const record = this.props.record
    return (
      !_.isEmpty(_.get(record, 'nomeResponsavel', '')) &&
      !_.isEmpty(_.get(record, 'nomeFalecido', '')) &&
      !_.isEmpty(_.get(record, 'foneResponsavel', ''))
    )
  }

  render() {
    const content = (
      <PbAtendimentoForm
        record={this.props.record}
        setField={this.props.setField}
        onClickSolicitarAtendimento={this.onClickSolicitarAtendimento}
        canSolicitarAtendimento={this.canSolicitarAtendimento}
      />
    )

    return <Page content={content} header={this.buildHeader()} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PbAtendimentoFormPageContainer)
